import useSidePageWithTableCtrl from '@/shared/SidePage/useSidePageWithTableCtrl'
import { IParameter } from '../../parameters.types'
import Table from '@/shared/Tables/Table'
import parametersTableFields from './parameters.table.fields'
import useRegularTable from '@/shared/Tables/Table/ctrl/useRegularTable'
import ParameterSidePage from '../ParameterSidePage'
import { memo } from 'react'

interface IProps {
  items: IParameter[]
}

const ParameterTable = (props: IProps) => {
  const sidePageCtrl = useSidePageWithTableCtrl<IParameter>(props.items)

  const tableCtrl = useRegularTable({
    fields: parametersTableFields,
    tableKey: `parameters`,
    itemKey: 'id',
    items: props.items,
  })

  return (
    <>
      <Table
        {...tableCtrl}
        items={props.items as any}
        itemKey="id"
        onClick={sidePageCtrl.handleItemPageOpen}
        loading={false}
      />
      <ParameterSidePage
        onCloseAnimationEnd={sidePageCtrl.handleCloseAnimationEnd}
        open={sidePageCtrl.sidePageOpen}
        onClose={sidePageCtrl.handleClosePage}
        parameter={sidePageCtrl.selectedItem}
      />
    </>
  )
}

export default memo(ParameterTable)
